import React from "react";
import Helmet from "react-helmet";
import SEO from "../components/SEO";
import "../assets/css/App.css";
import "../assets/css/index.css";
import Layout from "../components/Layout";
import { Jumbotronv2 } from "../components/Jumbotronv2";
import { ServicesBlock2 } from "../components/ServicesBlock2";
import { Brands } from "../components/Branding";
import { RE } from "../components/Reviews";
import ContactForm from "../components/ContactForm";

export default ({ data }) => (
  <Layout>
    <SEO
      title="Property & Block Management Heating Services | BBIS Heating"
      description="BBIS Heating specialises in providing heating services to residential blocks and managed properties across London, Hertfordshire and the surrounding areas. Contact us today."
      keywords="block management heating services, communal heating systems, residential heating London, property management heating, CP12 certificates, heating for managed properties, communal boiler servicing, heating engineers London, heating repairs for flats, heating zoning systems, swimming pool boiler servicing, pressurisation units, heating maintenance London"
    />
    <Jumbotronv2
      imgName="j2"
      headingTag={"Property & Block Management Heating Services"}
      descriptionTag={"Professional heating services for residential blocks and managed properties across London, Hertfordshire and the surrounding areas"}
      showOverlay={true}
    />

    <div className="white-segment">
      <h2 className="heading-color">Reliable heating and hot water for your tenants with minimal disruption</h2>
      <p>
        Heating and hot water are essential services for residential blocks and managed properties. Whether you're responsible for a single building or an entire portfolio, you need a heating partner you can rely on to act fast, work efficiently and deliver long-lasting solutions.
      </p>
      <p>
        At BBIS Heating, we work with property managers and block management companies to maintain and repair communal and individual heating systems across London and the home counties. Our engineers are Gas Safe-registered and experienced in servicing and repairing a wide range of commercial and residential systems.
      </p>
    </div>

    <div className="grey-segment">
      <h2 className="heading-color">Complete heating services for residential blocks</h2>
      <ul>
        <li>Plant rooms</li>
        <li>Commercial and communal boiler servicing and repairs</li>
        <li>Individual flat heating systems</li>
        <li>Heating controls and system zoning</li>
        <li>Gas safety certificates (CP12) for communal areas and individual units</li>
        <li>Pressurisation units and pumps</li>
        <li>Radiators, valves and pipework</li>
        <li>Swimming pool and spa boilers (if applicable)</li>
      </ul>

      <h2 className="heading-color">Flexible scheduling to avoid tenant disruption</h2>
      <p>
        We understand that access and timing can be challenging in residential settings. That’s why we offer flexible appointments and work with managing agents and residents to minimise disruption, whether we’re attending for a planned service or an emergency repair.
      </p>
    </div>

    <div className="white-segment">
      <h2 className="heading-color">A trusted partner for property professionals</h2>
      <p>BBIS Heating is already trusted by a wide range of property management companies across London. Our team provides reliable, responsive support.</p>
      <ul>
        <li>Keeping tenants safe and warm</li>
        <li>Avoiding reputational damage or complaints</li>
        <li>Managing costs and efficiency across multiple buildings</li>
        <li>Ensuring compliance with gas safety legislation and insurance requirements</li>
      </ul>

      <h2 className="heading-color">Why choose BBIS Commercial Heating?</h2>
      <ul>
        <li>Same or next working day repair service</li>
        <li>5-star ratings and reviews</li>
        <li>Over 50 years of experience in domestic and commercial heating</li>
        <li>Friendly, local engineers with experience working in managed properties</li>
      </ul>

      <ServicesBlock2 />
      <Brands />
      <h3 className="heading-color">What our customers say</h3>
      <RE />
    </div>

    <div className="grey-segment">
      <h3 className="heading-color">We provide commercial heating services all over London, Hertfordshire and the surrounding areas</h3>
      <p>
        With decades of experience supporting property managers, landlords and housing providers, BBIS Heating is here to help.
      </p>
      <ContactForm />
    </div>
  </Layout>
);
